import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Teamcomps.css";
import Footer from "./Footer";
//import pokemons from "./pokemonData";

const Teamcomps = () => {
  const [teamcomps, setTeamcomps] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://poke-meta.com/api/teamcomps")
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP Fehler: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => setTeamcomps(data.reverse()))
      .catch((err) => {
        console.error("Fehler beim Abrufen der Teamcomps:", err);
        setError(err.message);
      });
  }, []);

  // Funktion zur Navigation bei Klick
  const handleClick = (id) => {
    navigate(`/teamcompdetails/${id}`);
  };

  return (
    <div className="teamcomp-container">
      <h1 className="teamcomp-title">Best Teamcomps</h1>
      {error && <p className="error-message"> Fehler: {error}</p>}
      {teamcomps.length === 0 && !error && <p> Lade Teamcomps...</p>}
      
      {teamcomps.map((team) => (
        
        <div key={team.id} className="teamcomp-box" onClick={() => handleClick(team.id)}>
        <p className="teamcomp-dashboard-rating">Tier: {team.rating}</p>  
          {/* 6x1 Grid für Teamcomp */}
          <div className="teamcomp-grid">
          
            {team.pokemon_list.map((img, i) => (
              <div key={i} className="teamcomp-grid-cell">
                <img src={img} alt="Pokémon" className="teamcomp-image" />
              </div>
            ))}
          </div>
        </div>
      ))}
      <Footer />
    </div>
  );
};

export default Teamcomps;
